import ChangeProfilePicture from "./ChangeProfilePicture"
import EditProfile from "./EditProfile"
import DeleteAccount from "./DeleteAccount"
import UpdatePassword from "./UpdatePassword"

export default function Settings() {
    return (
        <div>
             <div style={{ fontFamily: "Arial, sans-serif" }}>
            <h1 className="mb-12 ml-12 md:ml-10 text-3xl font-medium text-blue-600">Edit Profile</h1>
            {/* change profile picture */}
            <ChangeProfilePicture/>
            {/* edit profile */}
            <EditProfile/>
            {/* password */}
            {/* <UpdatePassword/> */}
            {/* delete account */}
            <DeleteAccount/>
            </div>
        </div>
    )
}



// import ChangeProfilePicture from "./ChangeProfilePicture"
// import EditProfile from "./EditProfile"
// import DeleteAccount from "./DeleteAccount"
// import UpdatePassword from "./UpdatePassword"

// export default function Settings() {
//     return (
//         <div>
//             <h1 className="mb-14 text-3xl font-medium text-richblack-800 ml-16 md:ml-0">Edit Profile</h1>
//             {/* change profile picture */}
//             <ChangeProfilePicture/>
//             {/* edit profile */}
//             <EditProfile/>
//             {/* password */}
//             {/* <UpdatePassword/> */}
//             {/* delete account */}
//             <DeleteAccount/>
//         </div>
//     )
// }
